import { useDesktop } from "../hooks";
import { motion } from "framer-motion";
import { LoginComp } from "../components";

const Login = () => {
  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0.4 }}
      transition={{ duration: 0.5 }}
      className="login"
    >
      {useDesktop() >= 1024 && (
        <section className="login-showcase-content">
          <h1>Welcome Back</h1>
          <p>Sign in to your account to keep learning</p>
        </section>
      )}

      <LoginComp />
    </motion.main>
  );
};

export default Login;
